<h3>Atualizar Cutoff Padrão - {{ type }}</h3>

<form [formGroup]="form" (ngSubmit)="submit()">
  <div class="card mt-3">
    <div class="card-header text-uppercase">Horário Limite</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-12">
          <span *ngIf="accountManagerName"
            >Gestora: {{ accountManagerName }}</span
          >
          <span *ngIf="!accountManagerName">Gestora: (todas)</span>
        </div>
        <div class="col-12">
          <span *ngIf="fundName">Fundo: {{ fundName }}</span>
          <span *ngIf="!fundName">Fundo: (todos)</span>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6">
          <label for="timeLimit">Horário Limite</label>
          <input
            type="time"
            class="form-control"
            id="timeLimit"
            name="timeLimit"
            formControlName="timeLimit"
            placeholder="horário limite"
            pattern="[0-9]{2}:[0-9]{2}"
            required
          />
        </div>
      </div>
      <div class="row mb-2">
        <div>
          <label for="isActive">Ativo</label>
          <input
            type="checkbox"
            id="isActive"
            name="isActive"
            formControlName="isActive"
            class="form-check-input"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="actions">
    <input
      type="button"
      value="Atualizar"
      class="btn btn-primary"
      appDebounceClick
      (debounceClick)="submit()"
      [debounceTime]="200"
    />
  </div>

  <div>
    <table
      *ngIf="history && history.length > 0"
      class="table table-striped table-hover"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Data</th>
          <th scope="col">Usuário</th>
          <th scope="col">Horário Limite</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of history">
          <td>{{ item.creationDate | date: "dd/MM/yyyy HH:mm:ss" }}</td>
          <td>{{ item.creationUser }}</td>
          <td>{{ item.timeLimit | date: "HH:mm":"-0300" }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</form>
